export const ROOTS = {
  AUTH: '/account',
  DASHBOARD: '',
  WORKSPACES: '/workspaces',
  ADMIN_USERS: '/admin/users',
  ADMIN_LIVE_MONITORING: '/admin/features/live-monitoring',
  ADMIN_LIVE_BIDDING: '/admin/features/live-bidding',
  ADMIN_SSO: '/admin/sso',
  ADMIN_ONBOARD: '/admin/onboard',
};

// ----------------------------------------------------------------------

export const paths = {
  profile: {
    root: ROOTS.AUTH,
  },
  // DASHBOARD
  dash: {
    root: ROOTS.DASHBOARD,
    nonBrandOverview: ROOTS.DASHBOARD + '/non-branded/search-terms',
    nonBrandCompetitors: ROOTS.DASHBOARD + '/non-branded/competitors',
    //
    competitorsMonitoring: ROOTS.DASHBOARD + '/competitors-monitoring',
    competitorFocus: ROOTS.DASHBOARD + '/competitor-focus',
    textAds: ROOTS.DASHBOARD + '/text-ads',
    productListingAds: ROOTS.DASHBOARD + '/product-listing-ads',
    brandWayback: ROOTS.DASHBOARD + '/brand-wayback',
    campaignExplorer: ROOTS.DASHBOARD + '/optimization/campaigns',
    activeMode: ROOTS.DASHBOARD + '/optimization/activations/active-mode',
    optimizationActivationsOverview: "/optimization/activations/overview",
    koBiddingMaxCPC: ROOTS.DASHBOARD + '/optimization/activations/ko-bidding/max-cpc',
    koBiddingTROAS: ROOTS.DASHBOARD + '/optimization/activations/ko-bidding/troas',
    koBiddingTCPA: ROOTS.DASHBOARD + '/optimization/activations/ko-bidding/tcpa',
    scraping: ROOTS.DASHBOARD + '/optimization/scraping',
    koBiddingTargetImpressionShare: ROOTS.DASHBOARD + '/optimization/activations/ko-bidding/target-impression-share',
    koBiddingAuto: ROOTS.DASHBOARD + '/optimization/activations/ko-bidding-auto',
    competitiveOverview: ROOTS.DASHBOARD + '/competitive-intelligence/overview',
    competitiveIntelligence: ROOTS.DASHBOARD + '/competitive-intelligence',
    competitiveLandscape: ROOTS.DASHBOARD + '/competitive-intelligence/competitive-landscape',
    competitiveSearchTermAnalysis: ROOTS.DASHBOARD + '/competitive-intelligence/st-analysis',
    competitiveAds: ROOTS.DASHBOARD + '/competitive-intelligence/ads',
    //
    businessOverview: ROOTS.DASHBOARD + '/business-overview',
    brandOverview: ROOTS.DASHBOARD + '/brand-overview',

    //
    optimization: ROOTS.DASHBOARD + '/optimization',
    overview: ROOTS.DASHBOARD + '/optimization/overview',
    conversionsAnalysis: ROOTS.DASHBOARD + '/optimization/conversions-analysis',
    trafficAnalysis: ROOTS.DASHBOARD + '/optimization/funnel',
    trafficDetails: ROOTS.DASHBOARD + '/optimization/traffic-details',

    //
    creative: ROOTS.DASHBOARD + '/creative',
    landing: ROOTS.DASHBOARD + '/landing',
    video: ROOTS.DASHBOARD + '/videos',
    copy: ROOTS.DASHBOARD + '/copy',
    performance: ROOTS.DASHBOARD + '/performance/facebook',
    attribution: ROOTS.DASHBOARD + '/attribution',
    applications: {
      connections: {
        create: (type: string) => `/apps/${type}/connect`,
        app: (type: string) => `/apps/${type}`,
        root: `/apps`,
      },
    },
  },
  admin: {
    user: ROOTS.ADMIN_USERS,
    userAdd: `${ROOTS.ADMIN_USERS}/add`,
    liveMonitoring: ROOTS.ADMIN_LIVE_MONITORING,
    liveMonitoringAdd: `${ROOTS.ADMIN_LIVE_MONITORING}/add`,

    liveBiddingKeywordBased: `${ROOTS.ADMIN_LIVE_BIDDING}/search`,
    liveBiddingKeywordBasedActiveMode: `${ROOTS.ADMIN_LIVE_BIDDING}/search/active-mode`,

    liveBiddingKeywordBasedKoBidding: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding`,
    liveBiddingKeywordBasedKoBiddingMaxCPC: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/max-cpc`,
    liveBiddingKeywordBasedKoBiddingTROAS: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/troas`,
    liveBiddingKeywordBasedKoBiddingTCPA: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/tcpa`,
    liveBiddingKeywordBasedKoBiddingTargetImpressionShare: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/target-impression-share`,
    liveBiddingKeywordBasedKoBiddingAuto: `${ROOTS.ADMIN_LIVE_BIDDING}/search/ko-bidding/auto`,

    liveBiddingCampaignBased: `${ROOTS.ADMIN_LIVE_BIDDING}/campaign-based`,
    liveBiddingAdGroupBased: `${ROOTS.ADMIN_LIVE_BIDDING}/ad-group-based`,

    workspaces: ROOTS.WORKSPACES,
    workspacesAdd: `${ROOTS.WORKSPACES}/add`,
    workspacesSetup: `${ROOTS.WORKSPACES}/setup`,
    workspacesSetupEdit: `${ROOTS.WORKSPACES}/:id/setup`,

    sso: {
      root: ROOTS.ADMIN_SSO,
      add: `${ROOTS.ADMIN_SSO}/add`,
      list: `${ROOTS.ADMIN_SSO}/list`,
      edit: (id: number) => `${ROOTS.ADMIN_SSO}/${id}/edit`,
      delete: (id: number) => `${ROOTS.ADMIN_SSO}/${id}/delete`,
    },

    onboard: {
      root: ROOTS.ADMIN_ONBOARD,
      banners: {
        list: `${ROOTS.ADMIN_ONBOARD}/cai4phiegh1ooW3ahnoh9eiruTae6ca5/banners`,
        add: `${ROOTS.ADMIN_ONBOARD}/cai4phiegh1ooW3ahnoh9eiruTae6ca5/banners/add`,
      },
    },

  },
  workspaces: {
    root: ROOTS.WORKSPACES,
    workspace: (id: number) => `${ROOTS.WORKSPACES}/${id}`,
  }
};
